import { render, staticRenderFns } from "./_purchases.vue?vue&type=template&id=23c475e4&scoped=true&"
import script from "./_purchases.vue?vue&type=script&lang=js&"
export * from "./_purchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c475e4",
  null
  
)

export default component.exports